// mapped from BrokerSettingGroup.SettingGroupNames enum in Venus
// entire mapping has been omitted for decluttering. Add on an adhoc basis.
export enum BrokerSettingGroupNames {
    LoanTerms = 941,
    BrokerPortalReportingColumns = 942,
    RenewableStcDocumentExempted = 945,
    RenewableInvoiceDocumentExempted = 947
}
